export default __webpack_public_path__ + "static/media/3370.fe370831.png";